import type { OpaqueRefCountedBuffer, VideoFrameV2 } from '@mimir/cutter/frameProvider/frameProvider';
import { WebGlTextureWrapper } from './webGlWrapper';

export function tryGetWebGlTextureFromVideoFrame(videoFrame: VideoFrameV2): WebGlTextureWrapper | null {
  if (videoFrame.buffer instanceof WebGlTextureBuffer) {
    return videoFrame.buffer.texture;
  }
  return null;
}

export class WebGlTextureBuffer implements OpaqueRefCountedBuffer {
  refcount = 1;
  constructor(readonly texture: WebGlTextureWrapper) {
  }

  addReference(): OpaqueRefCountedBuffer {
    if (this.refcount <= 0) {
      throw new Error('Cannot add reference to a closed ImageBitmapBuffer');
    }
    ++this.refcount;
    return this;
  }

  size(): number {
    return this.texture.width * this.texture.height * 4;
  }

  copyTo(target: Uint8Array): Promise<void> {
    throw new Error('TODO: WebGlTextureBuffer.copyTo');
  }
  close(): void {
    --this.refcount;
    if (this.refcount <= 0) {
      this.texture.close();
    }
  }
}
